import {
  Avatar,
  Badge,
  Button,
  ConfigProvider,
  Dropdown,
  Popover,
  Segmented,
  Space,
  Switch,
  Tag,
  Tooltip,
  Typography,
} from 'antd';
const { Text } = Typography;
import React, { useContext, useState } from 'react';
// import Avatar from '../../../../assets/customSVG/Avatar';
import Assign from '../../../../assets/customSVG/inbox/Assign';
import Favorite from '../../../../assets/customSVG/inbox/Favourite';
import InboxThreeDot from '../../../../assets/customSVG/inbox/InboxThreeDot';
import MarkUnread from '../../../../assets/customSVG/inbox/MarkUnread';
import ListViewSearch from '../../../../components/commonComponents/ListViewHeader/ListViewSearch';
import RadioButton from '../../../../components/form/radio/RadioButton';
import { getRandomColorsBassedOnLetters } from '../../../../helper/colors';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import ConversationAssignment from './InboxUtils/ChatHeader/ConversationAssignment';
import {
  engageAgent,
  favoriteConversation,
} from '../../../../reduxToolkit/inboxSlice';
import OnlineUserList from './InboxUtils/ChatHeader/OnlineUserList';
import {
  ArrowsAltOutlined,
  RobotOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import ChatMetaData from './InboxUtils/ChatHeader/ChatMetaData';
import UserFilled from '../../../../assets/customSVG/inbox/webchat/UserFilled';
import EndUser from './InboxUtils/ChatHeader/EndUser';
import AgentEngagement from './InboxUtils/ChatHeader/AgentEngagement';
import { showSuccessToast } from '../../../../components/commonComponents/gxAntdToast/toastUtils';
import NotificationContext from '../../../../providers/NotificationProvider';

const ChatHeader = ({ className }) => {
  // hooks
  const dispatch = useDispatch();
  const toast = useContext(NotificationContext);

  // selectors
  const { selectedWebChatConversation, selectedWebChatTeam } = useSelector(
    (state) => state?.inbox,
  );
  const isTeamLead = selectedWebChatTeam?.role_name === 'T_LDR';
  const { currentBrand } = useSelector((state) => state?.app);
  const { id: conversation_id, agent_engagement_status } =
    selectedWebChatConversation;

  // handlers
  const handleFavoriteConversation = async () => {
    const res = await dispatch(
      favoriteConversation({
        brand_id: currentBrand?.brand_id,
        team_id: selectedWebChatTeam?.team_id,
        conversation_id: conversation_id,
        team_member_id: selectedWebChatTeam?.team_member_id,
        method:
          selectedWebChatConversation?.favorite_status == 10 ? 'delete' : 'put',
      }),
    );

    if (res?.payload?.res?.status == 10) {
      showSuccessToast(toast, 'Conversation added to favorites', 2);
    } else {
      showSuccessToast(toast, 'Conversation removed from favorites', 2);
    }
  };

  return (
    <div
      className={`bg-white rounded-br-lg shadow-sm px-6 flex align-center relative z-10 ${className}`}
    >
      <div className="w-full flex items-center space-between gap-[0.8vw] transition-all">
        {/* Sec 1 */}
        <ChatMetaData />
        {/* Sec 2 */}
        <div className="flex  align-center justify-center gap-10">
          <div className="flex align-center gap-2 rounded-lg hover:bg-slate-100 p-2 transition-all ">
            <ConversationAssignment />
            <ArrowsAltOutlined
              rotate={45}
              style={{ color: !agent_engagement_status && '#87d068' }}
            />
            <EndUser />
            <ArrowsAltOutlined
              rotate={45}
              style={{ color: agent_engagement_status && '#87d068' }}
            />
            <Avatar
              style={{ backgroundColor: agent_engagement_status && '#87d068' }}
              icon={<RobotOutlined />}
              shape="square"
            />
          </div>

          <AgentEngagement
            isTeamLead={isTeamLead}
            agent_engagement_status={agent_engagement_status}
          />
        </div>
        {/* Sec 3 */}
        <div
          className={`flex-row align-center gap-5 inbox-conversation-header`}
        >
          <OnlineUserList count={1} />

          <div
            onClick={handleFavoriteConversation}
            className="flex-column align-center gap-1 cursor-pointer"
          >
            <Favorite
              color={
                selectedWebChatConversation?.favorite_status == 10
                  ? 'var(--a)'
                  : 'var(--font-600)'
              }
              applyFill={
                selectedWebChatConversation?.favorite_status == 10
                  ? 'var(--a)'
                  : 'var(--font-600)'
              }
            />
            <Text className="text-xs">Favorite</Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
